import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Field, FieldMap, QueryBuilderClassNames, QueryBuilderConfig, Rule } from '../../../global/query-builder/query-builder.interfaces';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { FieldDictionaryDto } from 'src/app/tabms/models/base/base';
import { QueryStateService } from 'src/app/tabms/services/global/query-state.service';

@Component({
  selector: 'app-base-filter',
  templateUrl: './base-filter.component.html',
  styleUrl: './base-filter.component.scss'
})
export class BaseFilterComponent<T> implements OnInit {
  title;
  public queryCtrl: UntypedFormControl;

  public bootstrapClassNames: QueryBuilderClassNames = {
    removeIcon: 'fa fa-minus',
    addIcon: 'fa fa-plus',
    arrowIcon: 'fa fa-chevron-right px-2',
    button: 'btn',
    buttonGroup: 'btn-group',
    rightAlign: 'order-12 ml-auto',
    switchRow: 'd-flex px-2',
    switchGroup: 'd-flex align-items-center',
    switchRadio: 'custom-control-input',
    switchLabel: 'custom-control-label',
    switchControl: 'custom-control custom-radio custom-control-inline',
    row: 'row p-2 m-1',
    rule: 'border',
    ruleSet: 'border',
    invalidRuleSet: 'alert alert-danger',
    emptyWarning: 'text-danger mx-auto',
    operatorControl: 'form-control',
    operatorControlSize: 'col-auto pr-0',
    fieldControl: 'form-control',
    fieldControlSize: 'col-auto pr-0',
    entityControl: 'form-control',
    entityControlSize: 'col-auto pr-0',
    inputControl: 'form-control',
    inputControlSize: 'col-auto'
  };

  public query;

  public entityConfig: QueryBuilderConfig;

  public config: QueryBuilderConfig;

  public currentConfig: QueryBuilderConfig;
  public allowRuleset: boolean = true;
  public allowCollapse!: boolean;
  public persistValueOnFieldChange: boolean = false;
  appearance: MatFormFieldAppearance = 'outline';
  serviceInstance;
  fieldsConfigServiceInstance: FieldsConfigService<T>;
  currentLang: string;
  constructor(
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private translate: TranslateService,
    private baseService: BaseService,
    private queryStateService: QueryStateService
  ) {
    this.queryCtrl = this.formBuilder.control(this.query);
    //this.currentConfig = this.config;
    this.serviceInstance = data.service;
    this.fieldsConfigServiceInstance = data.fieldsConfigServiceInstance;
    this.title = this.translate.instant('customFilter');
    this.currentLang = this.baseService.getCurrentLanguage();
  }

  ngOnInit(): void {
    // console.log('service', this.serviceInstance, 'fields', this.fieldsConfigServiceInstance);
    this.getConfig();
  }

  getConfig() {
    let config: QueryBuilderConfig = { fields: {} };
    let entityConfig = {
      entities: {
        physical: { name: 'Physical Attributes' },
        nonphysical: { name: 'Nonphysical Attributes' }
      },
      fields: {}
    };

    let fieldMap: FieldMap = {};
    let entityFieldMap: FieldMap = {};
    let rules: Rule[] = [];
    this.fieldsConfigServiceInstance.filterColumns.subscribe((filterColumns: FieldDictionaryDto[]) => {
      console.log('filterColumns', filterColumns);
      filterColumns.forEach((filterColumn: FieldDictionaryDto) => {
        fieldMap[filterColumn.fieldname] = {
          name: filterColumn.fieldname,
          type: this.getFieldType(filterColumn.fieldtype),
          nullable: true,
          displayName: this.currentLang == 'ar' ? filterColumn.displayaraname : filterColumn.dislaylatname
        };
        entityFieldMap[filterColumn.fieldname] = {
          name: filterColumn.fieldname,
          type: this.getFieldType(filterColumn.fieldtype),
          nullable: true,
          entity: 'nonphysical',
          displayName: ''
        };
        rules.push({ field: filterColumn.fieldname, operator: 'is not null', entity: 'nonphysical' });
      });
      // debugger
      config.fields = fieldMap;
      this.config = config;
      console.log('this.config', this.config);
      entityConfig.fields = entityFieldMap;
      this.entityConfig = entityConfig;
      // console.log('this.entityConfig', this.entityConfig);
      this.currentConfig = this.config;

      const query = this.queryStateService.getQueryState() || { condition: 'and', rules: [] };

      if (query.rules && query.rules.length > 0) {
        this.query = query;
      } else {
        this.query = {
          condition: 'and',
          rules: []
        };
      }
    });
  }

  switchModes(event: Event) {
    this.currentConfig = (<HTMLInputElement>event.target).checked ? this.entityConfig : this.config;
  }

  changeDisabled(event: Event) {
    (<HTMLInputElement>event.target).checked ? this.queryCtrl.disable() : this.queryCtrl.enable();
  }

  applyFilter() {
    console.log('filter', this.query);
    this.queryStateService.setQueryState(this.query);

    let sqlQury = '';
    this.query.rules.forEach((rule) => {
      rule['value'] = rule['value']?.toString().trim(); // Remove leading and trailing spaces
      // debugger
      if (sqlQury != '') sqlQury = sqlQury + ' ' + this.query.condition;

      sqlQury = sqlQury + ' ' + rule.field + ' ' + rule.operator; //+ ' N'+''

      if (rule.operator == 'contains') sqlQury = sqlQury + '(' + "'";
      else if (rule.operator == 'like') sqlQury = sqlQury + "'" + '%';
      else if (rule.operator == '=' || rule.operator == '!=') sqlQury = sqlQury + "'";

      if (rule['value'] && rule.operator != 'is null' && rule.operator != 'is not null') sqlQury = sqlQury + rule['value'];

      if (rule.operator == 'contains') sqlQury = sqlQury + "'" + ')';
      else if (rule.operator == 'like') sqlQury = sqlQury + '%' + "'";
      else if (rule.operator == '=' || rule.operator == '!=') sqlQury = sqlQury + "'";
    });
    // console.log('sqlQury', sqlQury);
    this.baseService.applyFilter.next(sqlQury);
  }

  clearData() {
    this.queryStateService.clearQueryState();

    this.query = {
      condition: 'and',
      rules: []
    };
    this.baseService.refreshTable.next(true);
  }

  getFieldType(fieldType) {
    let type = 'string';
    if (this.checkNumericType(fieldType)) type = 'number';
    return type;
  }

  checkNumericType(fieldType) {
    if (
      fieldType == 'decimal' ||
      fieldType == 'numeric' ||
      fieldType == 'float' ||
      fieldType == 'real' ||
      fieldType == 'int' ||
      fieldType == 'bigint' ||
      fieldType == 'smallint' ||
      fieldType == 'tinyint' ||
      fieldType == 'money' ||
      fieldType == 'smallmoney'
    )
      return true;
    return false;
  }
}
